export const TRIAL_PAYWALL_QUERY_KEYS = {
  STATUS: 'TRIAL_STATUS',
} as const;

export const TRIAL_STATUS_ENDPOINT = '/companies/trial/status';
